<template lang="html">
  <div class="product-tip" v-if="$store.state.tip">
    <!-- <div class="item-cell">
            <div class="item-cell-hd">提示</div>
            <div class="item-cell-bd" v-if="$store.state.tip.link === ''">{{$store.state.tip.prompt}}</div>
            <div class="item-cell-bd" v-else @click="trace">
                <a :href="$store.state.tip.link">{{$store.state.tip.prompt}}</a>
            </div>
        </div> -->
    <!-- <wrapper>       -->
    <div class="cell">
      <div class="cell-l">
        <span class="key pf-medium"> 提示 </span>
        <span class="value" v-if="$store.state.tip.link === ''">{{
          $store.state.tip.prompt
        }}</span>
        <a :href="$store.state.tip.link" class="value" v-else @click="trace">{{
          $store.state.tip.prompt
        }}</a>
      </div>
      <!-- <i class=" cell-r icon-show-more" /> -->
    </div>
    <!-- </wrapper> -->
  </div>
</template>

<script>
import Wrapper from '../../wrapper'

export default {
  PAGE_ID: '288990',
  methods: {
    trace() {}
  },
  components: {
    Wrapper
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';

.product-tip {
  background: #fff;
  height: rem(100px);
  padding-left: rem(30px);
  .cell {
    height: rem(100px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    .cell-l {
      width: 90%;
      overflow: hidden;
      white-space: nowrap;
      display: flex;
      align-items: center;
      text-overflow: ellipsis;
      .key {
        font-size: rem(26px);
        color: #121212;
        margin-right: rem(36px);
      }
      .value {
        // line-height: rem(100px);
        // height: rem(100px);
        // display: inline-block;
        // border-top: rem(1.6px) solid  #f0f0f0;
        font-size: rem(26px);
        color: #262626;
        margin-right:rem(36px) a {
          color: #262626 !important;
        }
      }
    }
  }
  @include border(top, #f0f0f0);

  &::before {
    left: 1.2rem;
    right: 0.3rem;
  }
}

// .product-tip {
//     // margin: rem(20px) 0;
//     // background: #fee7a0;
//     // color: #9a7126;
//     height: rem(100px);

//     &::before{
//         left: rem(20px);
//         right: rem(20px);
//     }

//     .item-cell{
//         align-items: flex-start;
//         font-size: rem(28px);
//         padding:rem(5px) rem(12px) rem(30px) rem(20px);
//     }
//     .item-cell-hd{
//         padding-right: 0;
//         color: #666666;
//         font-size: rem(28px);
//         background: #fff;
//         width: rem(64px);
//         height: rem(32px);
//         line-height: rem(32px);
//         text-align: center;
//         margin-right: rem(25px);
//     }
//     .oneLine{
//         white-space: nowrap;
//         overflow: hidden;
//         text-overflow: ellipsis;
//     }
//     .item-cell-bd{
//         font-size: rem(26px);
//         overflow: hidden;
//         height: rem(32px);
//         line-height: rem(32px);
//          a{
//              color: #121212;
//          }
//     }
// }
</style>
